module.exports = __webpack_public_path__ + "static/media/autre-ak.c088f1ca.jpg";